module.exports = __webpack_public_path__ + "static/media/apparel5.52ed2209.jpg";